export default __webpack_public_path__ + "static/media/modern-bg.ff7dc77a.jpg";